import { bvaAPI } from 'api'
import { BVADetails } from 'model/BVADetails'

export const fetchBvaDetails = (id: string) => bvaAPI.get<BVADetails>(`/bva/${id}`)
